import React, { useContext } from 'react';
import DesktopDevPageDisplaySide300x250 from '@wix/da-ads/pkg/adunits/DesktopDevPageDisplaySide300x250';
import MobileDevPageDisplaySide300x250 from '@wix/da-ads/pkg/adunits/MobileDevPageDisplaySide300x250';
import DesktopDevPageSideVideoSide from '@wix/da-ads/pkg/adunits/DesktopDevPageSideVideoSide';
import ErrorBoundary from '../../../../ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './Ad.scss';
const Ad = ({ block , adSafety , deviation  })=>{
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety);
    const isDaAds = useFlag('ads_da');
    if (!showAd) {
        return null;
    }
    // Mobile only has BTF
    if (isMobile && block.contentType === 'ad_top') {
        return null;
    }
    if (isDaAds && block.contentType === 'ad_top') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SidebarAd"
    }, block.contentType === 'ad_top' && /*#__PURE__*/ React.createElement("div", {
        className: s['video']
    }, /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSide, {
        safety: adSafety
    })), block.contentType === 'ad_btf' && /*#__PURE__*/ React.createElement("div", {
        className: s['display']
    }, !isMobile && /*#__PURE__*/ React.createElement(DesktopDevPageDisplaySide300x250, {
        safety: adSafety
    }), isMobile && /*#__PURE__*/ React.createElement(MobileDevPageDisplaySide300x250, {
        safety: adSafety
    }))));
};
Ad.displayName = 'Ad';
export default Ad;
